import { Box, Stack, Typography, Tab } from "@mui/material";
import { Tabs } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { HiTemplate } from "react-icons/hi";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import CourseDiscussionList from "./courseDiscussionList";
import CourseDiscussionFlaggedList from "./courseDiscussionFlaggedList";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`course-discussion-tabpanel-${index}`}
      aria-labelledby={`course-discussion-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 2 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `course-discussion-tab-${index}`,
    'aria-controls': `course-discussion-tabpanel-${index}`,
  };
}

export default function ManageCourseDiscussion() {
  const { id } = useParams();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Appbar />
      <Drawer />
      <Body>
        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <HiTemplate size={30} />
          <Typography>Course Discussion</Typography>
        </Stack>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="course discussion tabs">
            <Tab label="Discussion" {...a11yProps(0)} />
            <Tab label="Flagged Discussion" {...a11yProps(1)} />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <CourseDiscussionList courseId={id} />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <CourseDiscussionFlaggedList courseId={id} />
        </TabPanel>
      </Body>
    </>
  );
}
